import { useEffect, useState } from 'react'

interface Dimensions {
    height: number
    width: number
}

export function useDimensions(): Dimensions {
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight - 71 - 40,
        width: window.innerWidth
    })

    useEffect(() => {
        function handleResize(): void {
            setDimensions({
                height: window.innerHeight - 71 - 40, // 70 live header, 40 risk managment header
                width: window.innerWidth
            })
        }

        window.addEventListener('resize', handleResize)

        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return dimensions
}
